"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var isZeroQuery_exports = {};
__export(isZeroQuery_exports, {
  isZeroQuery: () => isZeroQuery
});
module.exports = __toCommonJS(isZeroQuery_exports);
function _type_of(obj) {
  "@swc/helpers - typeof";
  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function isZeroQuery(obj) {
  if (!obj) return false;
  if ((typeof obj === "undefined" ? "undefined" : _type_of(obj)) !== "object") return false;
  if (!obj.ast || !obj.ast.table) return false;
  return true;
}
//# sourceMappingURL=isZeroQuery.js.map
